export default __webpack_public_path__ + "resources/icons/d141-a9fd.png";